"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
var React = require("react");
var utilities_1 = require("@fluentui/utilities");
var theme_1 = require("@fluentui/theme");
var ThemeContext_1 = require("./ThemeContext");
/**
 * Get theme from CustomizerContext or Customizations singleton.
 */
function useCompatTheme() {
    return (0, utilities_1.useCustomizationSettings)(['theme']).theme;
}
/**
 * React hook for programmatically accessing the theme.
 */
var useTheme = function () {
    var theme = React.useContext(ThemeContext_1.ThemeContext);
    var legacyTheme = useCompatTheme();
    return theme || legacyTheme || (0, theme_1.createTheme)({});
};
exports.useTheme = useTheme;
//# sourceMappingURL=useTheme.js.map